import { ErrorFallbackProps, ErrorFallbackBase } from './ErrorFallbackBase';

// Niveau 1 (RootErrorBoundary) : catastrophe, rien ne marche
export const UnexpectedErrorFallback = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase {...props} showDebugDetails showLogout showGitSha />
);
